import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function CtaFinalSection() {
  const [selectedOption, setSelectedOption] = useState<'basic' | 'pro'>('pro');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBumpSelected, setIsBumpSelected] = useState(false);
  const handleCtaClick = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const checkoutUrls = {
    basic: 'https://checkout.infinita-mente.online/checkouts/cn/hWNAChFvuHaB2PhnPBLg73vV/es-ar?_r=AQABxCv2H8l-9fZnoNQOgvcR5sYzfmJ62LD_4RX7yPhnTyc&preview_theme_id=138558668898:1',
    basicWithBump: 'https://checkout.infinita-mente.online/checkouts/cn/hWNACh4LOwqFGvkMT5FkniL3/es-ar?_r=AQAB2DeXup9TvKl_DwlZC7ZLI4B29o_OJUwH722Dj1GMy3g&preview_theme_id=138558668898:1',
    pro: 'https://checkout.infinita-mente.online/checkouts/cn/hWNACgqjbPVk00Xa5OlHr93R/es-ar?_r=AQABt2dxqci0XN1BO2V7ujzhmsZiBPbWUWE8Ck3FyQ-_E9w&preview_theme_id=138558668898:1',
    proWithBump: 'https://checkout.infinita-mente.online/checkouts/cn/hWNAChxRuekZ8lyYygHY8VU1/es-ar?_r=AQABsCOLaaWdA1Irc4wWXj9Jeh2MILTfBEBNNBm8vV7J5m0&preview_theme_id=138558668898:1'
  };
  const getCheckoutUrl = () => {
    if (selectedOption === 'basic' && isBumpSelected) return checkoutUrls.basicWithBump;
    if (selectedOption === 'pro' && isBumpSelected) return checkoutUrls.proWithBump;
    return checkoutUrls[selectedOption];
  };
  return <section id="elegir-opcion" className="w-full py-24 bg-transparent px-4 font-sans relative overflow-hidden" data-id="element-123">
      {/* Background Glows */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[400px] bg-gradPurple/10 blur-[150px] rounded-full pointer-events-none" data-id="element-124" />

      <div className="max-w-3xl mx-auto flex flex-col items-center relative z-10" data-id="element-125">
        {/* Badge */}
        <div className="bg-gradOrange/20 border border-gradOrange/50 text-gradOrange font-bold text-sm md:text-base px-6 py-2 rounded-full mb-6 flex items-center gap-2 shadow-[0_0_15px_rgba(255,107,0,0.3)]" data-id="element-126">
          <span data-id="element-127">⏰</span> OFERTA ESPECIAL LIMITADA
        </div>

        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-black text-white mb-12 text-center tracking-tight" data-id="element-128">
          Elegí tu opción
        </h2>

        {/* Pricing Container */}
        <div className="w-full max-w-xl bg-cardBg/90 backdrop-blur-md rounded-[2rem] p-6 md:p-8 border-2 border-gradPurple/30 shadow-[0_0_50px_rgba(138,43,226,0.2)] flex flex-col relative overflow-visible" data-id="element-129">
          {/* Option 1: Basic */}
          <div onClick={() => setSelectedOption('basic')} className={`relative w-full rounded-2xl p-5 cursor-pointer transition-all duration-300 flex items-center gap-4 ${selectedOption === 'basic' ? 'border-2 border-gradPurple bg-gradPurple/20 shadow-[0_0_20px_rgba(138,43,226,0.3)]' : 'border-2 border-white/10 bg-white/5 hover:bg-white/10'}`} data-id="element-130">
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOption === 'basic' ? 'border-gradPurple bg-gradPurple' : 'border-white/40 bg-transparent'}`} data-id="element-131">
              {selectedOption === 'basic' && <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-132" />}
            </div>
            <div className="flex-1 flex justify-between items-center gap-2" data-id="element-133">
              <div data-id="element-134">
                <h3 className="text-lg md:text-xl font-black text-white leading-tight" data-id="element-135">
                  MEGA PACK UNIVERSITARIO
                </h3>
                <p className="text-white/70 text-sm font-medium" data-id="element-136">
                  5 Tomos + 3 bonos gratis
                </p>
              </div>
              <div className="text-right" data-id="element-137">
                <div className="text-white/50 line-through text-xs md:text-sm font-bold" data-id="element-138">
                  $39.998
                </div>
                <div className="text-xl md:text-3xl font-black text-white leading-tight" data-id="element-139">
                  $19.999
                </div>
              </div>
            </div>
          </div>

          {/* Spacer between options */}
          <div className="my-4" data-id="element-140" />

          {/* Badges aligned above Pro option */}
          <div className="flex justify-center gap-3 mb-3 relative z-10" data-id="element-141">
            <div className={`text-[11px] md:text-xs font-black px-4 py-1.5 rounded-full flex items-center gap-1 uppercase tracking-widest transition-all duration-300 ${selectedOption === 'pro' ? 'bg-gradient-to-r from-gradOrange to-gradPink text-white shadow-[0_0_20px_rgba(255,107,0,0.5)] scale-105' : 'bg-white/10 text-white/40 shadow-none scale-100'}`} data-id="element-142">
              ⭐ MÁS ELEGIDO
            </div>
            <div className={`text-[11px] md:text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest backdrop-blur-sm transition-all duration-300 ${selectedOption === 'pro' ? 'bg-white/15 border border-white/30 text-white shadow-md' : 'bg-white/5 border border-white/10 text-white/40 shadow-none'}`} data-id="element-143">
              AHORRÁS $22.000
            </div>
          </div>

          {/* Option 2: Pro */}
          <div onClick={() => setSelectedOption('pro')} className={`relative w-full rounded-2xl p-5 cursor-pointer transition-all duration-300 flex items-center gap-4 ${selectedOption === 'pro' ? 'border-2 border-gradPurple bg-gradPurple/20 shadow-[0_0_20px_rgba(138,43,226,0.3)]' : 'border-2 border-white/10 bg-white/5 hover:bg-white/10'}`} data-id="element-144">
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOption === 'pro' ? 'border-gradPurple bg-gradPurple' : 'border-white/40 bg-transparent'}`} data-id="element-145">
              {selectedOption === 'pro' && <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-146" />}
            </div>
            <div className="flex-1 flex justify-between items-center gap-2" data-id="element-147">
              <div data-id="element-148">
                <h3 className="text-lg md:text-xl font-black text-white leading-tight" data-id="element-149">
                  MEGAPACK PRO
                </h3>
                <p className="text-white/70 text-sm font-medium leading-snug mt-0.5" data-id="element-150">
                  5 Tomos + 3 bonos + Protocolo Elite
                </p>
              </div>
              <div className="text-right" data-id="element-151">
                <div className="text-white/50 line-through text-xs md:text-sm font-bold" data-id="element-152">
                  $49.998
                </div>
                <div className="text-xl md:text-3xl font-black text-white leading-tight" data-id="element-153">
                  $27.999
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <motion.button onClick={handleCtaClick} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-full bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white font-black text-lg md:text-xl py-4 rounded-full mt-8 shadow-[0_0_15px_rgba(16,185,129,0.3)] transition-all flex items-center justify-center gap-2" data-id="element-154">
            SÍ, QUIERO MI PACK HOY →
          </motion.button>

          {/* Footer text */}
          <p className="text-center text-textMuted text-xs md:text-sm mt-4 font-medium" data-id="element-155">
            ¡La opción más elegida por los estudiantes universitarios que
            quieren romperla este cuatri!
          </p>
        </div>
      </div>

      {/* Order Bump Modal */}
      <AnimatePresence data-id="element-156">
        {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-157">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-cardBg/95 backdrop-blur-xl w-full max-w-md rounded-3xl p-6 md:p-8 shadow-[0_0_50px_rgba(138,43,226,0.3)] border border-gradPurple/50 relative" data-id="element-158">
              <div className="text-center mb-6" data-id="element-159">
                <h3 className="text-xl md:text-2xl font-black text-white mb-3 flex items-center justify-center gap-2" data-id="element-160">
                  <span className="text-gradOrange" data-id="element-161">🔥</span> ¡ESPERÁ! OFERTA
                  EXCLUSIVA <span className="text-gradOrange" data-id="element-162">🔥</span>
                </h3>
                <p className="text-white/90 text-base md:text-lg font-medium leading-snug" data-id="element-163">
                  Antes de finalizar, ¿querés agregar esto a tu compra?
                </p>
              </div>

              {/* Bump Item */}
              <div onClick={() => setIsBumpSelected(!isBumpSelected)} className={`w-full rounded-2xl border-2 p-5 cursor-pointer transition-all duration-300 mb-4 ${isBumpSelected ? 'border-gradOrange bg-gradOrange/10 shadow-[0_0_20px_rgba(255,107,0,0.2)]' : 'border-white/20 bg-white/5 hover:bg-white/10'}`} data-id="element-164">
                <div className="flex items-start gap-4" data-id="element-165">
                  <div className={`w-6 h-6 rounded border-2 flex items-center justify-center shrink-0 mt-0.5 ${isBumpSelected ? 'border-gradOrange bg-gradOrange' : 'border-white/40 bg-transparent'}`} data-id="element-166">
                    {isBumpSelected && <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-167" />}
                  </div>
                  <div className="flex-1" data-id="element-168">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2 gap-1" data-id="element-169">
                      <h4 className="text-base md:text-lg font-bold text-white leading-tight" data-id="element-170">
                        CENTRAL DE OPERACIONES: Cursada Sin Estrés
                      </h4>
                      <span className="text-gradOrange font-black text-lg md:text-xl" data-id="element-171">
                        $5.999
                      </span>
                    </div>
                    <p className="text-white/70 text-sm font-medium leading-snug" data-id="element-172">
                      Agregá este producto exclusivo a tu pedido con un solo
                      click
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-white/50 text-xs text-center mb-6 font-medium" data-id="element-173">
                Hacé click para agregar a tu pedido
              </p>

              {/* Modal CTA */}
              <a href={getCheckoutUrl()} target="_blank" rel="noopener noreferrer" className={`block w-full text-center font-black text-base md:text-lg py-4 rounded-full transition-all duration-300 mb-4 ${isBumpSelected ? 'bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white shadow-[0_0_15px_rgba(16,185,129,0.3)]' : 'bg-transparent border-2 border-[#10B981] text-[#10B981] hover:bg-[#10B981]/10'}`} data-id="element-174">
                {isBumpSelected ? 'AGREGAR Y CONTINUAR →' : 'CONTINUAR SIN AGREGAR →'}
              </a>

              <button onClick={handleCloseModal} className="w-full text-center text-textMuted hover:text-white text-sm font-medium transition-colors" data-id="element-175">
                ← Volver atrás
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </section>;
}